import { defineStore } from 'pinia'

export default defineStore({
  id: 'map',
  persist: true,
  state: () => {
    return {
      showJourney: true,
      showMap: {
        system: true,
        distributing: true,
        monitoringOwner: true,
        monitoringPartner: true,
        trip: true
      },
      showLocation: {
        system: false,
        route: false,
        order: false,
        priceVendor: false,
        businessOpportunity: false,
        distributing: false,
        monitoringOwner: false,
        monitoringPartner: false,
        trip: false
      } as { [key: string]: boolean },
      draggable: true
    }
  },
  actions: {
    setShowJourney: function (payload: boolean) {
      this.showJourney = payload
    },
    setShowMap: function (payload: { [key: string]: boolean }) {
      Object.assign(this.showMap, payload || {})
    },

    setShowLocation: function (payload: { [key: string]: boolean }) {
      Object.assign(this.showLocation, payload || {})
    },

    setDraggable: function (payload: boolean) {
      this.draggable = payload
    }
  },
  getters: {
    getShowJourney: (state: any) => state.showJourney,
    getShowMap: (state: any) => state.showMap,
    getShowLocation: (state: any) => state.showLocation,
    getDraggable: (state: any) => state.draggable
  }
})
